// src/services/investment.service.js
import apiClient from './api.service';

class InvestmentService {
  async getUserInvestments(userId) {
    const response = await apiClient.get(`/investments/user/${userId}`);
    return response.data;
  }

  async createInvestment(userId, investmentData) {
    const response = await apiClient.post(`/investments/user/${userId}`, {
      investmentType: investmentData.type,
      investmentName: investmentData.name,
      amount: parseFloat(investmentData.amount),
      startDate: investmentData.date,
      notes: investmentData.notes || 'Initial investment'
    });
    return response.data;
  }

  async deleteInvestment(investmentId, userId) {
    const response = await apiClient.delete(`/investments/${investmentId}/user/${userId}`);
    return response.data;
  }

  async getInvestmentDetails(investmentId) {
    const response = await apiClient.get(`/investments/${investmentId}`);
    return response.data;
  }
}

const investmentService = new InvestmentService();
export default investmentService;